<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import '@/assets/css/font.css'
  import '@/assets/css/my.css'
export default {
  name: 'App'
}
</script>

